module.exports = __webpack_public_path__ + "img/xlqy2.41bd8223.png";